export const GET_PENALTIES = "GET_PENALTIES"
export const GET_PENALTIES_SUCCESS = "GET_PENALTIES_SUCCESS"

export const API_ERROR = "EVENTS_API_ERROR"
